<mat-toolbar class="text-uppercase">
  <mat-toolbar-row>
    <span>Painel de Pendências e Atuações</span>
    <span class="spacer"></span>
    <button mat-raised-button color="primary" (click)="export()">
      Exportar
    </button>
  </mat-toolbar-row>
</mat-toolbar>

<mat-accordion>
  <form #thisForm="ngForm">
    <mat-card>
      <mat-card-header> </mat-card-header>
      <mat-card-content class="container-fluid">
        <div class="row mb-2">
          <div class="col-4">
            <mat-form-field>
              <mat-label>Tipo de Filtro</mat-label>
              <mat-select
                [(ngModel)]="monitorFilter.dateType"
                name="dateType"
                (ngModelChange)="dateTypeFilterChange()"
              >
                <mat-option
                  *ngFor="let item of filterDateTypes"
                  [value]="item.value"
                >
                  {{ item.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-4" [class.has-error]="periodoError()">
            <mat-form-field>
              <input
                matInput
                name="periodoDe"
                [(ngModel)]="monitorFilter.fromDate"
                [matDatepicker]="picker"
                placeholder="Do dia"
              />
              <mat-datepicker-toggle matSuffix [for]="picker">
              </mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="col-4">
            <mat-form-field>
              <mat-label>No. da Boleta</mat-label>
              <input
                matInput
                type="text"
                placeholder="ID Boleta"
                [(ngModel)]="monitorFilter.ticketId"
                name="IDBoleta"
              />
            </mat-form-field>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-4">
            <mat-form-field>
              <mat-label>Tipo de Operação</mat-label>
              <mat-select
                [(ngModel)]="monitorFilter.operationTypeId"
                name="operationTypeId"
              >
                <mat-option [value]="null"> (todos) </mat-option>
                <mat-option
                  *ngFor="let item of ListOperationTypes"
                  [value]="item.id"
                >
                  {{ item.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-4">
            <mat-form-field>
              <mat-label>Tipo de Liquidação</mat-label>
              <mat-select
                [(ngModel)]="monitorFilter.settlementTypeId"
                name="settlementTypeId"
              >
                <mat-option [value]="null"> (todos) </mat-option>
                <mat-option
                  *ngFor="let item of ListSettlementTypes"
                  [value]="item.id"
                >
                  {{ item.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-4">
            <mat-form-field>
              <mat-label>Boleta</mat-label>
              <mat-select
                [(ngModel)]="monitorFilter.ticketType"
                name="ticketType"
              >
                <mat-option [value]="null"> (todas) </mat-option>
                <mat-option *ngFor="let item of TicketTypes" [value]="item.id">
                  {{ item.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="row mb-2" *ngIf="!isAccountManager()">
          <div class="col-12">
            <mat-form-field>
              <input
                type="text"
                matInput
                placeholder="Gestor"
                [(ngModel)]="AccountManagerSelected"
                name="accountManager"
                [matAutocomplete]="auto"
              />
              <mat-autocomplete
                #auto="matAutocomplete"
                [displayWith]="exibeNomeAccountManager"
              >
                <mat-option
                  *ngFor="let item of filteredAccountManagers | async"
                  (click)="onAccManagerSelected(item)"
                  [value]="item"
                >
                  {{ item.document + " " + item.name }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-5">
            <mat-form-field>
              <input
                matInput
                type="text"
                placeholder="Nome do Fundo"
                [(ngModel)]="monitorFilter.fundName"
                name="nomeFundo"
              />
            </mat-form-field>
          </div>
          <div class="col-3">
            <mat-form-field>
              <input
                matInput
                type="text"
                placeholder="CNPJ"
                [(ngModel)]="monitorFilter.fundCnpj"
                name="cnpj"
                pattern="\d{2}[.]\d{3}[.]\d{3}\/\d{4}-\d{2}"
                [textMask]="{
                  mask: validator.documentLegalPersonMask,
                  guide: false
                }"
              />
            </mat-form-field>
          </div>
          <div class="col-2">
            <button
              mat-raised-button
              color="primary"
              type="button"
              (click)="clear()"
            >
              Limpar
            </button>
          </div>
          <div class="col-2">
            <button
              mat-raised-button
              color="primary"
              type="submit"
              (click)="filter()"
            >
              Buscar
            </button>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </form>
  <br />

  <mat-expansion-panel
    *ngIf="canDisplay(TicketTypeEnum.Quota)"
    [expanded]="this.ActiveTicketId == TicketTypeEnum.Quota"
  >
    <mat-expansion-panel-header>
      Cotas - ({{ orderedTicketsQuota ? this.quotaTotalItems : 0 }})
    </mat-expansion-panel-header>

    <mat-action-row>
      <button
        *ngIf="hasForwardRole(TicketTypeEnum.Quota)"
        mat-raised-button
        color="primary"
        type="submit"
        (click)="forwardMany(TicketTypeEnum.Quota)"
      >
        Encaminhar
      </button>
      <button
        *ngIf="hasApproveRole(TicketTypeEnum.Quota)"
        mat-raised-button
        color="primary"
        type="submit"
        (click)="approveManyLiquidation(TicketTypeEnum.Quota)"
      >
        Aprovar
      </button>
    </mat-action-row>

    <div class="container-fluid mb-4" *ngIf="orderedTicketsQuota != null">
      <div *ngFor="let year of orderedTicketsQuota.years; let i = index">
        <h5 class="mt-5" *ngIf="i != 0">{{ year }}</h5>
        <h5 *ngIf="i == 0">{{ year }}</h5>

        <div *ngFor="let month of orderedTicketsQuota.months">
          <div
            class="card mt-4"
            *ngIf="hasDataOn(year + '-' + month, TicketTypeEnum.Quota)"
          >
            <div class="card-header">
              <h6 class="text-uppercase mt-2">
                {{ monthToDate(year, month) | date: "MMMM" }}
              </h6>
            </div>

            <div *ngFor="let day of orderedTicketsQuota.days">
              <div
                class="card-body mt-2 mb-2"
                *ngIf="hasDataOn(month + '-' + day, TicketTypeEnum.Quota, true)"
              >
                <h6 class="card-title">Dia {{ day }}</h6>

                <div class="table-container">
                  <table mat-table [dataSource]="QuotaTables" class="col-12">
                    <ng-container matColumnDef="id">
                      <th mat-header-cell *matHeaderCellDef>Nº</th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.id }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="accountManagerName">
                      <th mat-header-cell *matHeaderCellDef>Nome do Gestor</th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.accountManagerName }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="accountManagerDocument">
                      <th mat-header-cell *matHeaderCellDef>CNPJ Gestor</th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.accountManagerDocument }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="operationDate">
                      <th mat-header-cell *matHeaderCellDef>Data Operação</th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.operationDate | date: "dd/MM/yyyy" }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="settlementDate">
                      <th mat-header-cell *matHeaderCellDef>
                        Data de Liquidação
                      </th>
                      <td mat-cell *matCellDef="let element">
                        <div *ngIf="!element.isManualSettlementDate">
                          {{ element.settlementDate | date: "dd/MM/yyyy" }}
                        </div>
                        <fa-icon
                          [icon]="faTriangleExclamation"
                          *ngIf="element.isManualSettlementDate"
                          title="Este fundo não possuí liquidez e, por isso, a data será preenchida manualmente pelo Administrador Fiduciário,
                          de acordo com o regulamento e a operação será liquidada na data preenchida."
                        ></fa-icon>
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="portfolioName">
                      <th mat-header-cell *matHeaderCellDef>Nome do Fundo</th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.portfolioName }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="isInternalFund">
                      <th mat-header-cell *matHeaderCellDef>Fundo Interno</th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.isInternalFund ? "SIM" : "NÃO" }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="portfolioDocument">
                      <th mat-header-cell *matHeaderCellDef>CNPJ</th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.portfolioDocument }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="portfolioAccount">
                      <th mat-header-cell *matHeaderCellDef>Conta Corrente</th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.portfolioAccount }}
                      </td>
                    </ng-container>

                    <!-- specifics -->

                    <ng-container matColumnDef="cetipAccount">
                      <th mat-header-cell *matHeaderCellDef>Conta Cetip</th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.portfolioCetipAccount }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="operationTypeId">
                      <th mat-header-cell *matHeaderCellDef>Tipo Operação</th>
                      <td mat-cell *matCellDef="let element">
                        {{
                          QuotaOperationTypesDescription[
                            element.operationTypeId
                          ]
                        }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="fundType">
                      <th mat-header-cell *matHeaderCellDef>
                        Tipo de Cota do Condomínio
                      </th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.fundType }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="settlementTypeId">
                      <th mat-header-cell *matHeaderCellDef>Tipo Liquidação</th>
                      <td mat-cell *matCellDef="let element">
                        {{
                          SettlemenTypesDescription[element.settlementTypeId]
                        }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="fundName">
                      <th mat-header-cell *matHeaderCellDef>Fundo Investido</th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.fundName }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="quotaValue">
                      <th mat-header-cell *matHeaderCellDef>Valor da Cota</th>
                      <td mat-cell *matCellDef="let element">
                        {{
                          element.quotaValue | currency: "R$":"symbol":"1.2-2"
                        }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="isCetipVoice">
                      <th mat-header-cell *matHeaderCellDef>CETIP Voice</th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.isCetipVoice ? "SIM" : "NÃO" }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="cetipVoiceId">
                      <th mat-header-cell *matHeaderCellDef>
                        ID Registro Cetip Voice
                      </th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.cetipVoiceId }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="operationValue">
                      <th mat-header-cell *matHeaderCellDef>
                        Valor da Operação
                      </th>
                      <td mat-cell *matCellDef="let element">
                        {{
                          element.operationValue
                            | currency: "R$":"symbol":"1.2-2"
                        }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="amount">
                      <th mat-header-cell *matHeaderCellDef>Quantidade</th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.amount | number }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="mnemonicCode">
                      <th mat-header-cell *matHeaderCellDef>
                        Código Mnemônico / CETIP do Fundo
                      </th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.mnemonicCode }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="counterpartName">
                      <th mat-header-cell *matHeaderCellDef>
                        Nome Contraparte
                      </th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.counterpartName }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="counterpartCetipAccount">
                      <th mat-header-cell *matHeaderCellDef>
                        Conta Cetip Contraparte
                      </th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.counterpartCetipAccount }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="fundBank">
                      <th mat-header-cell *matHeaderCellDef>Banco</th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.fundBank }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="fundBranch">
                      <th mat-header-cell *matHeaderCellDef>Agência</th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.fundBranch }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="fundAccount">
                      <th mat-header-cell *matHeaderCellDef>Conta</th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.fundAccount }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="isNewFund">
                      <th mat-header-cell *matHeaderCellDef>
                        É novo fundo no mercado?
                      </th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.isNewFund ? "SIM" : "NÃO" }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="statusId">
                      <th mat-header-cell *matHeaderCellDef>Status</th>
                      <td mat-cell *matCellDef="let element">
                        {{ WorkflowStatusDescription[element.statusId || -1] }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="elapsedTime">
                      <th mat-header-cell *matHeaderCellDef>Tempo Decorrido</th>
                      <td mat-cell *matCellDef="let element">
                        <span
                          *ngIf="
                            element.elapsedTime &&
                            element.elapsedTime.hours >= 1
                          "
                        >
                          {{ element.elapsedTime.hours | number: "1.0-0" }}h
                        </span>
                        <span
                          *ngIf="
                            element.elapsedTime && element.elapsedTime.hours < 1
                          "
                        >
                          {{ element.elapsedTime.minutes | number: "1.0-0" }}min
                        </span>
                      </td>
                    </ng-container>

                    <ng-container
                      matColumnDef="statusElectronicTransferAvailable"
                    >
                      <th mat-header-cell *matHeaderCellDef>Status TED</th>
                      <td mat-cell *matCellDef="let element" class="actions">
                        <div *ngIf="element.statusElectronicTransferAvailable">
                          <a (click)="transferStatusDialog(element)">
                            <fa-icon
                              [icon]="faListAlt"
                              title="Visualizar"
                            ></fa-icon>
                            {{
                              element.statusElectronicTransferAvailable
                                | scpTicketTransferStatus
                            }}
                          </a>
                        </div>
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="lastStatusDate">
                      <th mat-header-cell *matHeaderCellDef>
                        Última atualização
                      </th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.lastStatusDate | date: "dd/MM/yyyy HH:mm" }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="actions" sticky>
                      <th mat-header-cell *matHeaderCellDef></th>
                      <td mat-cell *matCellDef="let element" class="actions">
                        <div>
                          <mat-checkbox
                            *ngIf="canCheck(TicketTypeEnum.Quota, element)"
                            (click)="$event.stopPropagation()"
                            (change)="
                              $event ? SelectionQuotas.toggle(element) : null
                            "
                            [checked]="SelectionQuotas.isSelected(element)"
                          >
                          </mat-checkbox>
                          <a
                            [routerLink]="[
                              MenuConstants.Tickets.Quota,
                              element.id
                            ]"
                          >
                            <fa-icon
                              [icon]="faListAlt"
                              title="Visualizar"
                            ></fa-icon>
                          </a>
                        </div>
                      </td>
                    </ng-container>

                    <tr
                      mat-header-row
                      *matHeaderRowDef="ColumnsQuota; sticky: true"
                    ></tr>
                    <tr
                      mat-row
                      *matRowDef="let row; columns: ColumnsQuota"
                    ></tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <paginador
          [listedPages]="quotaListedPages"
          [firstItemOnPage]="quotaFirstItemOnPage"
          [lastItemOnPage]="quotaLastItemOnPage"
          [totalPages]="quotaTotalPages"
          [totalItems]="quotaTotalItems"
          [currentPage]="quotaCurrentPage"
          [itemsPerPage]="[10, 25, 50, 100, 200]"
          (onSearch)="loadQuotaPaged($event[0], $event[1])"
        ></paginador>
      </div>
    </div>
  </mat-expansion-panel>

  <mat-expansion-panel
    *ngIf="canDisplay(TicketTypeEnum.Liabilities)"
    [expanded]="this.ActiveTicketId == TicketTypeEnum.Liabilities"
  >
    <mat-expansion-panel-header>
      Passivo - ({{ orderedTicketsLiability ? this.liabilitiesTotalItems : 0 }})
    </mat-expansion-panel-header>
    <mat-action-row>
      <button
        *ngIf="hasForwardRole(TicketTypeEnum.Liabilities)"
        mat-raised-button
        color="primary"
        type="submit"
        (click)="forwardMany(TicketTypeEnum.Liabilities)"
      >
        Encaminhar
      </button>
      <button
        *ngIf="hasApproveRole(TicketTypeEnum.Liabilities)"
        mat-raised-button
        color="primary"
        type="submit"
        (click)="approveManyLiquidation(TicketTypeEnum.Liabilities)"
      >
        Aprovar
      </button>
    </mat-action-row>

    <div class="container-fluid mb-4" *ngIf="orderedTicketsLiability != null">
      <div *ngFor="let year of orderedTicketsLiability.years; let i = index">
        <h5 class="mt-5" *ngIf="i != 0">{{ year }}</h5>
        <h5 *ngIf="i == 0">{{ year }}</h5>

        <div *ngFor="let month of orderedTicketsLiability.months">
          <div
            class="card mt-4"
            *ngIf="hasDataOn(year + '-' + month, TicketTypeEnum.Liabilities)"
          >
            <div class="card-header">
              <h6 class="text-uppercase">
                {{ monthToDate(year, month) | date: "MMMM" }}
              </h6>
            </div>

            <div *ngFor="let day of orderedTicketsLiability.days">
              <div
                class="card-body mt-2 mb-2"
                *ngIf="
                  hasDataOn(month + '-' + day, TicketTypeEnum.Liabilities, true)
                "
              >
                <h6 class="card-title">Dia {{ day }}</h6>

                <div class="table-container">
                  <table
                    mat-table
                    [dataSource]="LiabilityTables"
                    class="col-12"
                  >
                    <ng-container matColumnDef="id">
                      <th mat-header-cell *matHeaderCellDef>Nº</th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.id }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="accountManagerName">
                      <th mat-header-cell *matHeaderCellDef>Nome do Gestor</th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.accountManagerName }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="accountManagerDocument">
                      <th mat-header-cell *matHeaderCellDef>CNPJ Gestor</th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.accountManagerDocument }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="operationDate">
                      <th mat-header-cell *matHeaderCellDef>Data Operação</th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.operationDate | date: "dd/MM/yyyy" }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="settlementDate">
                      <th mat-header-cell *matHeaderCellDef>
                        Data de Liquidação
                      </th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.settlementDate | date: "dd/MM/yyyy" }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="portfolioName">
                      <th mat-header-cell *matHeaderCellDef>Nome do Cotista</th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.portfolioName }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="portfolioDocument">
                      <th mat-header-cell *matHeaderCellDef>CPF/CNPJ</th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.portfolioDocument }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="portfolioAccount">
                      <th mat-header-cell *matHeaderCellDef>Conta Corrente</th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.portfolioAccount }}
                      </td>
                    </ng-container>

                    <!-- specifics -->

                    <ng-container matColumnDef="cetipAccount">
                      <th mat-header-cell *matHeaderCellDef>Conta Cetip</th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.portfolioCetipAccount }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="operationTypeId">
                      <th mat-header-cell *matHeaderCellDef>Tipo Operação</th>
                      <td mat-cell *matCellDef="let element">
                        {{ OperationTypesDescription[element.operationTypeId] }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="settlementTypeId">
                      <th mat-header-cell *matHeaderCellDef>Tipo Liquidação</th>
                      <td mat-cell *matCellDef="let element">
                        {{
                          SettlemenTypesDescription[element.settlementTypeId]
                        }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="fundName">
                      <th mat-header-cell *matHeaderCellDef>Fundo Investido</th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.fundName }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="quotaValue">
                      <th mat-header-cell *matHeaderCellDef>Valor da Cota</th>
                      <td mat-cell *matCellDef="let element">
                        {{
                          element.quotaValue | currency: "R$":"symbol":"1.2-2"
                        }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="operationValue">
                      <th mat-header-cell *matHeaderCellDef>
                        Valor da Operação
                      </th>
                      <td mat-cell *matCellDef="let element">
                        {{
                          element.operationValue
                            | currency: "R$":"symbol":"1.2-2"
                        }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="amount">
                      <th mat-header-cell *matHeaderCellDef>Quantidade</th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.amount | number }}
                      </td>
                    </ng-container>

                    <!-- <ng-container matColumnDef="mnemonicCode">
                    <th mat-header-cell *matHeaderCellDef>Código Mnemônico / CETIP do Fundo</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.mnemonicCode }}
                    </td>
                  </ng-container> -->

                    <ng-container matColumnDef="fundBank">
                      <th mat-header-cell *matHeaderCellDef>Banco</th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.fundBank }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="fundBranch">
                      <th mat-header-cell *matHeaderCellDef>Agência</th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.fundBranch }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="fundAccount">
                      <th mat-header-cell *matHeaderCellDef>Conta</th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.fundAccount }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="isNewFund">
                      <th mat-header-cell *matHeaderCellDef>
                        É novo fundo no mercado?
                      </th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.isNewFund ? "SIM" : "NÃO" }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="statusId">
                      <th mat-header-cell *matHeaderCellDef>Status</th>
                      <td mat-cell *matCellDef="let element">
                        {{ WorkflowStatusDescription[element.statusId || -1] }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="elapsedTime">
                      <th mat-header-cell *matHeaderCellDef>Tempo Decorrido</th>
                      <td mat-cell *matCellDef="let element">
                        <span
                          *ngIf="
                            element.elapsedTime &&
                            element.elapsedTime.hours >= 1
                          "
                        >
                          {{ element.elapsedTime.hours | number: "1.0-0" }}h
                        </span>
                        <span
                          *ngIf="
                            element.elapsedTime && element.elapsedTime.hours < 1
                          "
                        >
                          {{ element.elapsedTime.minutes | number: "1.0-0" }}min
                        </span>
                      </td>
                    </ng-container>

                    <ng-container
                      matColumnDef="statusElectronicTransferAvailable"
                    >
                      <th mat-header-cell *matHeaderCellDef>Status TED</th>
                      <td mat-cell *matCellDef="let element" class="actions">
                        <div *ngIf="element.statusElectronicTransferAvailable">
                          <a (click)="transferStatusDialog(element)">
                            <fa-icon
                              [icon]="faListAlt"
                              title="Visualizar"
                            ></fa-icon>
                            {{
                              element.statusElectronicTransferAvailable
                                | scpTicketTransferStatus
                            }}
                          </a>
                        </div>
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="lastStatusDate">
                      <th mat-header-cell *matHeaderCellDef>
                        Última atualização
                      </th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.lastStatusDate | date: "dd/MM/yyyy HH:mm" }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="actions" sticky>
                      <th mat-header-cell *matHeaderCellDef></th>
                      <td mat-cell *matCellDef="let element" class="actions">
                        <div>
                          <mat-checkbox
                            *ngIf="
                              canCheck(TicketTypeEnum.Liabilities, element)
                            "
                            (click)="$event.stopPropagation()"
                            (change)="
                              $event
                                ? SelectionLiabilities.toggle(element)
                                : null
                            "
                            [checked]="SelectionLiabilities.isSelected(element)"
                          >
                          </mat-checkbox>
                          <a
                            [routerLink]="[
                              MenuConstants.Tickets.Liabilities,
                              element.id
                            ]"
                          >
                            <fa-icon
                              [icon]="faListAlt"
                              title="Visualizar"
                            ></fa-icon>
                          </a>
                        </div>
                      </td>
                    </ng-container>

                    <tr
                      mat-header-row
                      *matHeaderRowDef="ColumnsLiabilities; sticky: true"
                    ></tr>
                    <tr
                      mat-row
                      *matRowDef="let row; columns: ColumnsLiabilities"
                    ></tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <paginador
          [listedPages]="liabilitiesListedPages"
          [firstItemOnPage]="liabilitiesFirstItemOnPage"
          [lastItemOnPage]="liabilitiesLastItemOnPage"
          [totalPages]="liabilitiesTotalPages"
          [totalItems]="liabilitiesTotalItems"
          [currentPage]="liabilitiesCurrentPage"
          [itemsPerPage]="[10, 25, 50, 100, 200]"
          (onSearch)="loadLiabilitiesPaged($event[0], $event[1])"
        ></paginador>
      </div>
    </div>
  </mat-expansion-panel>
</mat-accordion>
